export default {
  apiKey: 'AIzaSyDi1urNTTKB5K2Bo1j8lDnv9ITYHptaGqA',
  authDomain: 'propertyfirst-ee59e.firebaseapp.com',
  databaseURL: 'https://propertyfirst-ee59e.firebaseio.com',
  projectId: 'propertyfirst-ee59e',
  storageBucket: 'propertyfirst-ee59e.appspot.com',
  messagingSenderId: '648638012557'
}



// WEBPACK FOOTER //
// ./src/modules/firebase/firebaseConfig.js